import { useTheme } from '@mui/styles';

export const LEFT_COLUMN = 175;

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    cell: {
      padding: theme.spacing(0, 1, 0.5, 1),
      '&:first-of-type': { paddingLeft: theme.spacing(2) },
      '&:last-of-type': { paddingRight: theme.spacing(2) },
      borderBottom: 'none',
    },
    nameCell: {
      display: 'flex',
    },
    row: {
      cursor: 'pointer',
    },
  };
};
